'use strict'

var xhrEvents = {
  onabort: false,
  onerror: false,
  ontimeout: false,
  
  onloadstart: false,
  onprogress: false,
  onloadend: false,
  onload: false
}

export function ajax(options) {
  var xhr, promise, baseOptions
  baseOptions = {
    url: location.href,
    data: '',
    method: 'GET',
    
    timeout: 0,
    responseType: 'auto',
    
    username: null,
    password: null
  }
  options = Object.assign({}, baseOptions, xhrEvents, options)
  
  promise = new Promise(function (resolve, reject) {
    xhr = new XMLHttpRequest()
    
    xhr.timeout = options.timeout
    xhr.responseType = options.responseType == 'auto' ? '' : options.responseType
    
    xhr.open(options.method, options.url, true, options.username, options.password)
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    
    for (var key in xhrEvents) {
      if ( !options[key]) { continue }
      xhr.addEventListener(key.substring(2), options[key])
    }
    
    xhr.addEventListener('abort', reject)
    xhr.addEventListener('error', reject)
    xhr.addEventListener('timeout', reject)
    
    xhr.addEventListener('load', function(event) {
      var mimetype
      
      if (xhr.status >= 200 && xhr.status < 300) {
        xhr.ajaxResponse = xhr.response
        if (options.responseType == 'auto') {
          mimetype = xhr.getResponseHeader('Content-Type')
          if (mimetype === 'application/json; charset=UTF-8') {
            xhr.ajaxResponse = JSON.parse(xhr.ajaxResponse)
          }
        }
        
        resolve(event)
      } else {
        reject(event)
      }
    })
    
    xhr.send(options.data)
  })
  
  promise.abort = xhr.abort.bind(xhr)
  return promise
}

export function get(url, data, options) {
  options = Object.assign({}, options || {})
  data = data || {}
  
  url = new URL(url instanceof URL ? url.href : url, location.href)
  for (var key in data) {
    url.searchParams.append(key, data[key])
  }
  options.url = url.href
  
  return ajax(options)
}

export function post(url, data, options) {
  options = Object.assign({}, options || {})
  
  options.url = url
  options.data = data
  options.method = 'POST'
  
  return ajax(options)
}
